export const SET_COURSES = 'SET_COURSES';
export const SET_COURSE = 'SET_COURSE';
export const EDIT_COURSE = 'EDIT_COURSE';
export const DELETE_COURSE = 'DELETE_COURSE';
export const CLEAR_COURSES = 'CLEAR_COURSES';
export const ADD_COURSE = 'ADD_COURSE';
